import {
  Box,
  Modal,
  Typography,
  Grid,
  Divider,
  IconButton,
  Chip,
  alpha,
} from '@mui/material';
import React from 'react';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import dayjs from 'dayjs';

const cellStyle = {
  border: '1px solid #ddd',
  padding: '8px',
};

const DetailRow = ({ label, value, mono }) => (
  <>
    <Grid item xs={6} sx={cellStyle}>
      <Typography variant="body1" fontWeight="bold">
        {label}
      </Typography>
    </Grid>
    <Grid item xs={6} sx={cellStyle}>
      <Typography
        variant="body1"
        sx={mono ? { fontFamily: 'monospace', fontSize: '0.85rem', wordBreak: 'break-all' } : {}}
      >
        {value ?? '—'}
      </Typography>
    </Grid>
    <Grid item xs={12}>
      <Divider />
    </Grid>
  </>
);

const ViewRewardModal = ({ open, handleClose, reward }) => {
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { md: '50%', xs: '90%' },
    height: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 8,
    outLine: 'none',
    overflowY: 'auto !important',
    borderRadius: '20px',
    WebkitOverflowScrolling: 'touch',
    scrollbarWidth: 'thin',
    scrollbarColor: 'transparent transparent',
  };

  const isDebit = String(reward?.action || '').toUpperCase() === 'DEBIT';
  const actionColor = isDebit ? '#dc2626' : '#16a34a';
  const points = Number(reward?.points ?? reward?.point);
  const formattedPoints = Number.isFinite(points) ? points.toFixed(2) : '—';

  const sender =
    reward?.senderName ||
    reward?.giverName ||
    reward?.from?.username ||
    reward?.from?.email ||
    reward?.senderUserId ||
    '—';

  const receiver =
    reward?.receiverName ||
    reward?.to?.username ||
    reward?.to?.email ||
    reward?.receiverUserId ||
    '—';

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        <IconButton
          edge="end"
          color="inherit"
          onClick={handleClose}
          aria-label="close"
          sx={{
            position: 'absolute',
            top: '15px',
            right: '15px',
          }}
        >
          <HighlightOffOutlinedIcon />
        </IconButton>
        <Typography mb={5} variant="h3">
          Reward Details
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            textAlign: 'center',
          }}
        >
          {reward ? (
            <Grid container alignItems="center" justifyContent="center">
              <DetailRow label="Points" value={formattedPoints} />
              <DetailRow label="Sender" value={sender} />
              <DetailRow label="Sender user ID" value={reward?.senderUserId || reward?.giverUserId} mono />
              <DetailRow label="Receiver" value={receiver} />
              <DetailRow label="Receiver user ID" value={reward?.receiverUserId} mono />
              <Grid item xs={6} sx={cellStyle}>
                <Typography variant="body1" fontWeight="bold">
                  Action
                </Typography>
              </Grid>
              <Grid item xs={6} sx={cellStyle}>
                <Chip
                  label={reward?.action ? String(reward.action).toLowerCase() : '—'}
                  size="small"
                  sx={{
                    fontWeight: 700,
                    color: actionColor,
                    bgcolor: alpha(actionColor, 0.12),
                    textTransform: 'capitalize',
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <Divider />
              </Grid>
              <DetailRow label="Remarks" value={reward?.remarks || reward?.remark} />
              <DetailRow label="Transaction ID" value={reward?.transactionId} mono />
              <DetailRow label="Wallet ID" value={reward?.walletId} mono />
              <DetailRow
                label="Created on"
                value={
                  reward?.createdAt
                    ? dayjs(reward.createdAt).format('DD MMM YYYY, HH:mm')
                    : '—'
                }
              />
            </Grid>
          ) : (
            <Typography variant="body1">No reward selected</Typography>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default ViewRewardModal;
